import script from "./description.vue?vue&type=script&lang=ts&setup=true"
export * from "./description.vue?vue&type=script&lang=ts&setup=true"

import "./description.vue?vue&type=style&index=0&id=9be19ff0&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9be19ff0"]])

export default __exports__